import React from 'react';
// import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Flex,
  // useDisclosure,
} from '@chakra-ui/react';
// import { IconDots, IconTrash, IconCheck, IconArchive } from '@tabler/icons';
import { FaCheckSquare, FaTrash } from 'react-icons/fa';
import { TbDots } from 'react-icons/tb';
import { MdArchive } from 'react-icons/md';

// import api from 'api/axiosConfig';
import theme from 'ui/theme/theme';
import Text from 'ui/Text';

function StatusActionMenu({ item, updateStatus, isStory }) {
  const itemId = isStory ? item.storyId || 0 : item.essayId || 0;

  return (
    <Menu placement="bottom-end">
      <MenuButton as={Button} bg="unset">
        <Flex justifyContent="center">
          <TbDots color={theme.colors.semantics.link} />
        </Flex>
      </MenuButton>
      <MenuList
        padding="8px"
        w="150px"
        borderWidth="0px"
        boxShadow="0px 4px 30px 0px rgba(0, 0, 0, 0.15)"
      >
        {(item?.status == 'Published' || item?.status == 'Rescinded') && (
          <MenuItem p="8px" as="button" onClick={() => updateStatus(itemId, 2)}>
            <Flex alignItems="center" color="semantics.link">
              <MdArchive />
              <Text size="medium" ml="8px" fontWeight="bold">
                Unpublish
              </Text>
            </Flex>
          </MenuItem>
        )}
        {(item?.status == 'Finished' ||
          item?.status == 'Rescinded' ||
          item?.status == 'Pending') && (
          <MenuItem p="8px" as="button" onClick={() => updateStatus(itemId, 4)}>
            <Flex alignItems="center" color="semantics.link">
              <FaCheckSquare />
              <Text size="medium" ml="8px" fontWeight="bold">
                Publish
              </Text>
            </Flex>
          </MenuItem>
        )}
        {item?.status == 'Pending' && (
          <MenuItem p="8px" as="button" onClick={() => updateStatus(itemId, 5)}>
            <Flex alignItems="center" color="semantics.link">
              <MdArchive />
              <Text size="medium" ml="8px" fontWeight="bold">
                Reject
              </Text>
            </Flex>
          </MenuItem>
        )}
        {!(item?.status == 'Rescinded') && (
          <MenuItem p="8px" as="button" onClick={() => updateStatus(itemId, 6)}>
            <Flex alignItems="center" color="semantics.link">
              <FaTrash />
              <Text size="medium" ml="8px" fontWeight="bold">
                Rescind
              </Text>
            </Flex>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
}

StatusActionMenu.propTypes = {
  item: PropTypes.object,
  updateStatus: PropTypes.func,
  isStory: PropTypes.string.isRequired,
};

export default StatusActionMenu;
